<section class="dashboard-header-controls">
  <div class="dashboard-header-controls__infochip">
    @if (selectedPcr) {
      <mds-chip [disabled]="true" [removable]="false" [showChipIcon]="false" [label]="declarationUnitLabel"></mds-chip>
    }
    <mds-chip
      [disabled]="true"
      [label]="'Last updated: ' + (dataUpdated | utcDate: 'd MMM \'at\' HH:mm')"
      [removable]="false"
      [showChipIcon]="false"
    ></mds-chip>
  </div>

  <div class="dashboard-header-controls__selection">
    @for (dropdown of selectList; track dropdown.helperText) {
      <mds-dropdown-menu
        (selectedValueChange)="dropdown.change($event)"
        [helperText]="dropdown.helperText"
        [options]="dropdown.options"
        [selectedValue]="dropdown.selectedValue"
        [showArrows]="true"
        [text]="dropdown.text"
      ></mds-dropdown-menu>
    }
  </div>

  @if (canPreview) {
    <div class="dashboard-header-controls__buttons">
      <mds-button
        (click)="preview.emit()"
        [aria-label]="previewButtonLabel"
        [isIconLeft]="true"
        [icon]="'download'"
        type="primary"
      >
        {{ previewButtonLabel }}
      </mds-button>
    </div>
  }
</section>
